module.exports = __webpack_public_path__ + "img/20180913104404_bce96190bed64ccf97d9774780c2e3b2.33cd2374.png";